import { render, staticRenderFns } from "./CatalogCardList.vue?vue&type=template&id=5c0acd75&scoped=true"
import script from "./CatalogCardList.vue?vue&type=script&lang=js"
export * from "./CatalogCardList.vue?vue&type=script&lang=js"
import style0 from "./CatalogCardList.vue?vue&type=style&index=0&id=5c0acd75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0acd75",
  null
  
)

export default component.exports